import React, { Component } from 'react';
import Hls from 'hls.js';

import { isBrowser } from "react-device-detect";

function Timer(callback, delay) {
    var timerId, start, remaining = delay;

    this.pause = function () {
        window.clearTimeout(timerId);
        remaining -= new Date() - start;
    };

    this.resume = function () {
        start = new Date();
        window.clearTimeout(timerId);
        timerId = window.setTimeout(callback, remaining);
    };

    this.resume();
}

export default class HLSSource extends Component {
    constructor(props, context) {
        super(props, context);
        const config = {
            xhrSetup: function (xhr, url) {
                function minutes_with_leading_zeros(dt) 
                { 
                    return (dt.getMinutes() < 10 ? '0' : '') + dt.getMinutes();
                }
                function second_with_leading_zeros(dt) 
                { 
                    return (dt.getSeconds() < 10 ? '0' : '') + dt.getSeconds();
                }
                let m = minutes_with_leading_zeros(new Date()) + ':' + second_with_leading_zeros(new Date())
                xhr.setRequestHeader("Content-Language", m.slice(0, 4));
                // xhr.setRequestHeader("Referer", "test");
            }
        }
        this.hls = new Hls(config);
        this.state = { URL: '' }
    }

    getUrl = () => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        const { src } = this.props;
        fetch(src, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(response => { return Promise.all([response, response.json()]) })
            .then(([response, json]) => {
                if (response.status === 200) {
                    console.log(json)
                    const { video } = this.props;
                    this.setState({ URL: json.url })
                    if (Hls.isSupported()) {
                        this.hls.loadSource(json.url);
                        this.hls.attachMedia(video);
                        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                            video.play();
                        });
                    }
                } else {
                    console.error('ไม่สามารถสร้างคอร์สใหม่ได้')
                }
            }).catch(() => {
                console.error('ไม่สามารถเชื่อมต่อ service ได้')
            })
    }

    tick = () => {
        const { onTick } = this.props
        if (onTick) {
            onTick()
        }
    }

    componentDidMount() {
        const { src, video, duration } = this.props;
        if (Hls.isSupported()) {
            this.hls.loadSource(src);
            this.hls.attachMedia(video);
            this.hls.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
                console.log(event, data)
                video.play();

                if(!isBrowser) {
                    console.log("toggleFullscreen")
                    video.toggleFullscreen();
                }
            });
            this.hls.on(Hls.Events.LEVEL_LOADED, (event, data) => {
                console.log('timer ', data.details.totalduration * 10 / 100 * 1000)
                this.timer = new Timer(() => {
                    this.tick()
                }, data.details.totalduration * 10 / 100 * 1000);
            });
            this.hls.on(Hls.Events.DESTROYING, () => {
                console.log("Video OFF")
                this.timer.pause();
            })
        }
        // this.getUrl()
    }


    componentWillUnmount() {
        // destroy hls video source
        if (this.hls) {
            this.hls.destroy();
        }
    }

    render() {
        return (
            <source
                src={this.props.src}
                type={this.props.type || 'application/x-mpegURL'}
            />
        );
    }
}
